import { defineGameCard, drawCards, onResolve } from '../authoring/index.js';
import { hasFieldCardInEveryLocation } from './furniture_helpers.js';
export const FurnitureCatalogCard = defineGameCard({
    id: 'furniture_catalog',
    gameplay: {
        type: 'SPELL',
        cost: 2,
        minimumCost: 1,
        effectiveCost(state, instanceId, baseCost) {
            const controllerId = state.instances[instanceId]?.controllerId;
            return controllerId !== undefined && hasFieldCardInEveryLocation(state, controllerId)
                ? 1
                : baseCost;
        },
    },
    presentation: {
        name: 'Каталог мебельного магазина',
        description: 'Эта карта стоит 1 вместо 2, если у вас есть хотя бы одна карта на поле в каждой локации. Возьмите 2 карты.',
        glyph: {
            colors: ['#10213A', '#AB5431', '#FFD99E', '#853D29', '#BD6F35'],
            rows: [
                '....................',
                '....................',
                '.11111111..11111111.',
                '12222222311333333321',
                '12223333331334443321',
                '12233333221345554321',
                '12333333331345554321',
                '12334444331344444321',
                '12342222431333432321',
                '12342222431333433321',
                '12424224241333432321',
                '12424444241333433321',
                '12344444431323443321',
                '12333333331323333321',
                '12333333331333333221',
                '12333333331333332221',
                '12333222231332222221',
                '11111111111111111111',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [onResolve(drawCards(2))],
});
//# sourceMappingURL=furniture_catalog.js.map